import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const PaginationControls = ({ currentPage, totalPages, pageSize, totalCount, onPageChange, onPageSizeChange }) => {
  const pageSizeOptions = [10, 20, 50, 100];
  
  const startItem = (currentPage - 1) * pageSize + 1;
  const endItem = Math.min(currentPage * pageSize, totalCount);

  const handlePrevious = () => {
    if (currentPage > 1) {
      onPageChange(currentPage - 1);
    }
  };

  const handleNext = () => {
    if (currentPage < totalPages) {
      onPageChange(currentPage + 1);
    }
  };

  const getPageNumbers = () => {
    const pages = [];
    const maxVisible = 5;
    
    if (totalPages <= maxVisible) {
      for (let i = 1; i <= totalPages; i++) {
        pages?.push(i);
      }
    } else {
      if (currentPage <= 3) {
        for (let i = 1; i <= 4; i++) pages?.push(i);
        pages?.push('...');
        pages?.push(totalPages);
      } else if (currentPage >= totalPages - 2) {
        pages?.push(1);
        pages?.push('...');
        for (let i = totalPages - 3; i <= totalPages; i++) pages?.push(i);
      } else {
        pages?.push(1);
        pages?.push('...');
        pages?.push(currentPage - 1);
        pages?.push(currentPage);
        pages?.push(currentPage + 1);
        pages?.push('...');
        pages?.push(totalPages);
      }
    }
    
    return pages;
  };

  return (
    <div className="bg-card rounded-2xl shadow-2xl border border-white/8 p-6 mt-6">
      <div className="flex flex-col md:flex-row items-center justify-between gap-4">
        {/* Results Info */}
        <div className="text-sm text-secondary">
          Affichage de <span className="font-semibold text-primary">{startItem}</span> à{' '}
          <span className="font-semibold text-primary">{endItem}</span> sur{' '}
          <span className="font-semibold text-primary">{totalCount}</span> résultat(s)
        </div>

        {/* Page Size Selector */}
        <div className="flex items-center gap-2">
          <span className="text-sm text-muted">Afficher</span>
          <select
            value={pageSize}
            onChange={(e) => onPageSizeChange(Number(e?.target?.value))}
            className="px-3 py-2 bg-card-elevated border border-white/8 rounded-lg text-primary text-sm focus:ring-2 focus:ring-accent focus:border-transparent transition-all"
          >
            {pageSizeOptions?.map((size) => (
              <option key={size} value={size}>
                {size}
              </option>
            ))}
          </select>
          <span className="text-sm text-muted">par page</span>
        </div>

        {/* Pagination Buttons */}
        <div className="flex items-center gap-2">
          <Button
            onClick={handlePrevious}
            disabled={currentPage === 1}
            className="p-2 text-secondary hover:text-primary hover:bg-card-hover rounded-lg transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
          >
            <Icon name="ChevronLeft" size={20} />
          </Button>

          {getPageNumbers()?.map((page, index) => (
            page === '...' ? (
              <span key={`ellipsis-${index}`} className="px-3 py-2 text-muted">
                ...
              </span>
            ) : (
              <button
                key={page}
                onClick={() => onPageChange(page)}
                className={`px-4 py-2 rounded-lg font-medium transition-all ${
                  currentPage === page
                    ? 'bg-accent text-white shadow-lg'
                    : 'text-secondary hover:text-primary hover:bg-card-hover'
                }`}
              >
                {page}
              </button>
            )
          ))}

          <Button
            onClick={handleNext}
            disabled={currentPage === totalPages}
            className="p-2 text-secondary hover:text-primary hover:bg-card-hover rounded-lg transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
          >
            <Icon name="ChevronRight" size={20} />
          </Button>
        </div>
      </div>
    </div>
  );
};

export default PaginationControls;